import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalButton } from '@app/common/models/modal-button';

@Component({
    selector: 'ebs-modal-simple',
    templateUrl: './modal-simple.component.html',
    styleUrls: ['./modal-simple.component.scss'],
    standalone: false
})
export class ModalSimpleComponent implements OnInit {
  title: string;
  message: string;
  options: ModalButton[];
  answer = '';

  constructor(
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {}

  respond(answer: string) {
    this.answer = answer;
    this.bsModalRef.hide();
  }

}
